export const accountTrackingIDs = {
    addAuthorizedCustomer: {
        id: 'dagligbank-add-authorized-customer',
        name: 'add-authorized-customer',
    },
    deleteAuthorizedCustomer: {
        id: 'dagligbank-delete-authorized-customer',
        name: 'delete-authorized-customer',
    },
};
